// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";

import Modal, { ModalActions } from '../../../ui/Modal';
import FormGroup from '../../../ui/FormGroup';
import Input from '../../../ui/Input';
import { PlusIcon, TrashIcon } from '../../../ui/icons';
import { modalTypes } from '../../../../enums';
import { validateUrl } from '../../../../helper';

class FormsModal extends Component {
  state = { urlToAdd: '', error: false };

  cancel = () => {
    this.props.onClose();
    this.setState({ urlToAdd: '', error: false });
  }

  add = async () => {
    const url = this.state.urlToAdd;
    if (!validateUrl(url)) {
      this.setState({ error: true });
      return;
    }
    this.setState({ urlToAdd: '', error: false });
    this.props.onClose();
    await this.props.store.forms.addFormLink(url);
  }

  remove = async () => {
    await this.props.store.forms.removeFormLink(this.props.url);
    this.props.onClose();
  }

  render() {
    const { open, action, url } = this.props;
    const isAdd = action === modalTypes.add;
    return (
      <Modal
        open={open}
        onClose={this.cancel}
        size={isAdd ? 'md' : 'sm'}
        closeOnScrim={false}
        title={isAdd ? 'Add a form' : 'Delete form'}
        icon={isAdd ? PlusIcon : TrashIcon}
        sub={isAdd ? 'Enter the URL you want to track.' : undefined}
        actions={(
          <ModalActions
            onCancel={this.cancel}
            onConfirm={isAdd ? this.add : this.remove}
            confirmLabel={isAdd ? 'Add form' : 'Delete'}
            confirmVariant={isAdd ? 'primary' : 'danger'}
            confirmLoading={!isAdd && this.props.store.forms.loading}
          />
        )}
      >
        {isAdd ? (
          <FormGroup
            label="Form URL"
            help="Example: https://www.formurl.com"
            error={this.state.error ? 'That URL doesn\'t look right.' : null}
          >
            <Input
              value={this.state.urlToAdd}
              placeholder="https://www.formurl.com"
              onChange={(e) => this.setState({ urlToAdd: e.target.value, error: false })}
              invalid={this.state.error}
            />
          </FormGroup>
        ) : (
          <p className="m-0 text-[13px] text-mov-ink-soft">
            <b className="text-mov-ink">{url}</b> will be deleted permanently. This can&apos;t be undone.
          </p>
        )}
      </Modal>
    );
  }
}

export default inject('store')(observer(FormsModal));
